export default "__VITE_ASSET__Ohmj9C$p__"